export default __webpack_public_path__ + "static/media/berry_mountain_1280.38ac7b6a.webp";